<template>
  <section class="inner">
    <nav class="breadcrumb is-small has-dot-separator">
      <ul>
        <li>
          <b-icon icon="home" size="is-small" />
        </li>
        <li v-if="portefeuille" class="is-active">
          <a href="#">
            {{ portefeuille.name }}
          </a>
        </li>
      </ul>
    </nav>

    <b-tabs v-model="activeTab" :animated="false">
      <b-tab-item>
        <template slot="header">
          <b-icon icon="folder" size="is-small" />
          Documents
        </template>
        <div class="content has-text-grey has-text-centered">
          <p>Sélectionnez un bien dans la liste ci-contre</p>
        </div>
      </b-tab-item>

      <b-tab-item :visible="allowQuestions && cga">
        <template slot="header">
          <b-icon icon="question-circle" size="is-small" />
          Questions
        </template>
        <PortefeuilleQuestions
          v-if="this.$route.params.portefeuille"
          ref="question"
          :test="true"
          :includePortefeuilleData="true"
        />
        <div v-else class="content has-text-grey has-text-centered">
          <p>Sélectionnez un portefeuille dans la liste ci-contre</p>
        </div>
      </b-tab-item>

      <b-tab-item>
        <template slot="header">
          <b-icon icon="envelope" size="is-small" pack="far" />
          Notifications
        </template>
        <div class="content has-text-grey has-text-centered">
          <p>Sélectionnez un bien dans la liste ci-contre</p>
        </div>
      </b-tab-item>

      <b-tab-item>
        <template slot="header">
          <b-icon icon="file-earmark-text-fill" size="is-small" pack="far" />
          CGU
        </template>
        <div class="content has-text-grey has-text-centered">
          <CGA />
        </div>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import PortefeuilleQuestions from '@/components/Portefeuille/Questions'
import CGA from '@/components/Portefeuille/CGA.vue'

export default {
  components: {
    PortefeuilleQuestions,
    CGA,
  },
  created() {
     this.fetchCgaData();
  },
  data() {
    let activeTab = 0
    return {
      activeTab,
      cga: null,
    }
  },
  computed: {
    ...mapGetters({
      allowQuestions: 'inv/allowQuestions',
    }),
    ...mapState({
      user: state => state.user,
      biens: (state) => state.inv.biens,
    }),
    portefeuille() {
      if (!this.$route.params.portefeuille) return
      const value = this.biens.find(
        (i) => i.portefeuille === +this.$route.params.portefeuille
      )
      return value
        ? {
            id: value.portefeuille,
            name: value.portefeuilleName,
          }
        : null
    },
  },
  watch: {
    '$route.params.portefeuille': 'fetchCgaData',
    portefeuille() {
      this.$store.commit(
        'inv/PORTEFEUILLE_SETTINGS',
        this.$route.params.portefeuille
      )
    },
  },
  methods: {
    getuser(){

    },
    //use to check if CGA is valid or not and display question or not
    fetchCgaData() {
      if (this.$route.params.portefeuille) {
        this.$store
          .dispatch('getCgaValue', { user: this.user.name, id: this.$route.params.portefeuille })
          .then((data) => {
            this.cga = data
          })
          .catch((error) => {
            console.error(
              'Erreur lors de la récupération de la valeur CGA:',
              error
            )
          })
      } else {
        // Remettre la valeur de cga à null si $route.params.portefeuille n'est pas défini
        this.cga = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.inner {
  padding: 1em 1em;
}
.b-tabs {
  background: #fff;
}
</style>
